<template>
    <div v-show="shouldShowActionButtons()" class="actions">
        <button class="btn btn-icon btn-pure btn-danger btn-delete"
                data-original-title="Delete"
                data-toggle="tooltip"
                @click="confirmEntryRemoval()">
            <i class="fa fa-times"></i>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        removeEntry: {
            type: Function,
            required: true,
        },
    },
    methods: {
        shouldShowActionButtons() {
            return !(this.entry.id > 0)
        },
        confirmEntryRemoval() {
            Swal.fire(
                {
                    title: "Delete Entry?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#f2353c",
                    confirmButtonText: "Yes, delete!",
                }
            ).then(result => {
                if (result.isConfirmed) {
                    this.removeEntry(this.index);
                }
            });
        },
    }
}
</script>

<style scoped>

</style>
